export default {
  HOME: "/",
};
